import { render, staticRenderFns } from "./search-tpl.vue?vue&type=template&id=aae67500&scoped=true"
import script from "./search-tpl.vue?vue&type=script&lang=js"
export * from "./search-tpl.vue?vue&type=script&lang=js"
import style0 from "./search-tpl.vue?vue&type=style&index=0&id=aae67500&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aae67500",
  null
  
)

export default component.exports